export default {
  exnum_label: 'Exnum',
  exnum_placeholder: 'please enter your exnum',
  exnum_placeholder_check: 'Input not allowed /?*<>: ',
  type_label: 'Exnum Type',
  type_placeholder: 'please enter your exnum type',
  company_label: 'Exhibitors',
  company_placeholder: 'please enter your exhibitor name',
  area_label: 'Area(㎡)',
  area_placeholder: 'please enter your area',
  contact_label: 'Exhibitor contact',
  contact_placeholder: 'please enter your exhibitor name for contacting',
  mobile_label: 'Mobile',
  mobile_placeholder: 'please enter your mobile',
  email_label: 'Email',
  email_placeholder: 'please enter your email',
  email_error: 'email format is incorrect',
  fax_label: 'Fax',
  fax_placeholder: 'please enter your fax',
  remark_label: 'Remarks',
  remark_placeholder: 'please enter your remarks',
  tip: 'Tip',
  choose_booth: 'Choose Booth',
  choose_tip: 'In the following booths, check the booth that requires payment',
  special_booth: 'Special Booth',
  normal_booth: 'Normal Booth',
  add_booth: 'Add booth',
  relate_booth: 'Confirm',
	close_btn: 'Close',
  relate_tip: 'Please enter booth needed be related',
  special_exhibitor: 'Special booth exhibitor',
  normal_exhibitor: 'Normal booth exhibitor',
  relate_btn: 'Add Booth',
  add_btn: 'Add Booth',
  no_booth_err: 'The system could not find your booth ',
	"，可点击":"，you can click on the ",
  prop_title: 'Booth confirmation',
  prop_sure_pre: 'Are you sure',
  prop_sure_after: 'is your booth',
  bind_success: 'Successfully binding booth',
  bind_error: 'Failed to bind booth',
  add_success: 'Add booth successfully',
  add_error: 'Failed to add booth',
  add_booth_tip: 'Add Booth Tips',
  failed_to_add: 'Failed to add booth for exhibition configuration',
  failed_to_relate: 'Failed to relate booth for exhibition configuration',
  "未查询到该展位，请检查展位号后重试": "No data,please check the booth number and try again.",
  "请选择需要缴纳费用的展位，当前已选择": "Please select the booth that needs to pay the fee. At present, ",
  "个": "booths have been selected.",
  "暂无数据，请先添加展位": "No data, Please add booth first.",
  "新增展位":"New booth",
	"已新增展位":"New booths have been added",
  "返回上一页":"Back to previous page",
	"展位":"Exnum",
	"已被关联":"has been associated",
  booth_add:"add by booth number",
	exhibitors_add:"add by exhibiting company name",
  next_step:"Next step",
  return:"Return",
  previous:"Previous",
  no_search_booth_err:'If you can’t find the booth you want to add',


}



// WEBPACK FOOTER //
// ./src/i18n/en-us/chooseBooth.js